import React, { useRef } from 'react';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import { Growl } from 'primereact/growl';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import mensalidadeService from '../../../../services/mensalidades/mensalidadeService';

EnviarBoletoPorEmail.propTypes = {
    closeModal: PropTypes.func,
    email: PropTypes.string,
    setEmail: PropTypes.func,
    loading: PropTypes.bool,
    setLoading: PropTypes.func,
    parcelas: PropTypes.string,
    valorTotalFaturas: PropTypes.number,
    faturas: PropTypes.string,
    urlBoleto: PropTypes.string
};

export function EnviarBoletoPorEmail({
    closeModal,
    email,
    setEmail,
    loading,
    setLoading,
    parcelas,
    valorTotalFaturas,
    faturas,
    urlBoleto
}) {
    const mensagemToast = useRef(null);

    const mensagemSucesso = () => {
        mensagemToast.current.show({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Email enviado com sucesso!',
            life: 3000,
            closable: false
        });
    };

    const mensagemErro = () => {
        mensagemToast.current.show({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao enviar seu email! Por favor, tente mais tarde.',
            life: 4000,
            closable: false
        });
    };

    const initialValues = {
        email: email.toLowerCase()
    };

    const schema = yup.object().shape({
        email: yup
            .string()
            .max(50, 'O email deve ter no máximo 50 caracteres.')
            .email('Por favor insira um email válido')
            .required('Esse campo é obrigatório')
    });

    const handleSubmit = async values => {
        const valor = Number(parseFloat(valorTotalFaturas).toFixed(2));

        console.log(urlBoleto);

        const payloadRequisicao = {
            linkBoleto: urlBoleto,
            valor,
            email: values.email,
            faturas: faturas.split(',')
        };

        try {
            setLoading(true);
            await mensalidadeService.enviaBoletoEmail(payloadRequisicao);
            mensagemSucesso();
            setTimeout(() => {
                closeModal();
            }, 3000);
        } catch (err) {
            setEmail(values.email);
            setLoading(false);
            mensagemErro();
            throw new Error(err);
        }
    };

    return (
        <>
            <Growl ref={mensagemToast} />
            {loading ? (
                <div className="spinner-cartao">
                    <ProgressSpinner />
                </div>
            ) : (
                <div className="page-pdf-email">
                    <div className="content-cobranca-boleto">
                        <h1>Cobrança</h1>
                        <h2>
                            Valor: {''}
                            {new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }).format(valorTotalFaturas)}
                        </h2>
                        <h2>Faturas: {parcelas}</h2>
                    </div>
                    <div className="dialog-divider"></div>
                    <div className="content-boleto">
                        <Formik
                            initialValues={initialValues}
                            onSubmit={handleSubmit}
                            validationSchema={schema}
                        >
                            <Form>
                                <h2>Email:</h2>
                                <Field as={InputText} id="email" name="email" />
                                <ErrorMessage
                                    name="email"
                                    component="span"
                                    style={{ color: 'red' }}
                                />
                                <div className="actions">
                                    <Button label="Enviar" type="submit" />
                                    <Button
                                        label="Cancelar"
                                        className="p-button-danger"
                                        type="button"
                                        onClick={closeModal}
                                    />
                                </div>
                            </Form>
                        </Formik>
                    </div>
                </div>
            )}
        </>
    );
}
